import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

const deleteTag = async (tagId: number): Promise<void> => {
  await Axios.delete(DELETE_URL(String(tagId)).deleteTag);
};

export const useDeleteTag = () => {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, number>(deleteTag, {
    onSuccess: (_data, tagId) => {
      queryClient.invalidateQueries(['tags']);
      queryClient.removeQueries(['tag', tagId]);
      queryClient.invalidateQueries(['tagAssignments']);
    },
    useErrorBoundary: false
  });
};
